module.exports = __webpack_public_path__ + "hyperion-v2-static/img/seerist-feature-popup.2b7593bc.png";